(function (app) {
    app.constant("disclosePoints", [
        {
            Type: "Agent",
            ShortType: "Agent",
            Description: "Generated during transaction initiation",
            IsActive: false
        },
        {
            Type: "Entity",
            ShortType: "Entity",
            Description: "Upload the disclosures for your entity",
            IsActive: false
        },
        {
            Type: "Other Entities",
            ShortType: "OtherEntities",
            Description: "Pull disclosures for all entities in workflow",
            IsActive: false
        }
    ]);
})(window.app); // jshint ignore:line